<option value="">{{ normalized }}</option>
<option [value]="null">{{ normalized }}</option>
<option [value]="undefined">{{ normalized }}</option>
